/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_One_Time_Modal_DescriptionInputs */

const es_user_profile_api_keys_one_time_modal_description = /** @type {(inputs: User_Profile_Api_Keys_One_Time_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta es la única vez que podrás ver esta clave API. Copiala ahora y guardala de forma segura.`)
};

const en_user_profile_api_keys_one_time_modal_description = /** @type {(inputs: User_Profile_Api_Keys_One_Time_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the only time you will be able to see this API key. Copy it now and store it securely.`)
};

/**
* | output |
* | --- |
* | "This is the only time you will be able to see this API key. Copy it now and store it securely." |
*
* @param {User_Profile_Api_Keys_One_Time_Modal_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_one_time_modal_description = /** @type {((inputs?: User_Profile_Api_Keys_One_Time_Modal_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_One_Time_Modal_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_one_time_modal_description(inputs)
	return en_user_profile_api_keys_one_time_modal_description(inputs)
});
export { user_profile_api_keys_one_time_modal_description as "user.profile.api_keys.one_time_modal.description" }